"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastArrivals = void 0;
var react_1 = __importStar(require("react"));
var LastArrivals_module_scss_1 = __importDefault(require("./LastArrivals.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var Skeleton_1 = require("../skeleton/Skeleton");
var LastArrivalsSlider = react_1.default.lazy(function () { return Promise.resolve().then(function () { return __importStar(require('../lastArrivalsSlider/LastArrivalsSlider')); }); });
var LastArrivals = function () {
    return (react_1.default.createElement("section", { className: LastArrivals_module_scss_1.default.latest_arrivals },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: LastArrivals_module_scss_1.default.latest_arrivals__inner },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { className: LastArrivals_module_scss_1.default.latest_arrivals__title }, "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F"),
                    react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Skeleton_1.Skeleton, { height: 200, count: 3 }) },
                        react_1.default.createElement(LastArrivalsSlider, null))),
                react_1.default.createElement(react_router_dom_1.Link, { className: LastArrivals_module_scss_1.default.latest_arrivals__link, to: '/cars' }, "\u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 \u2192")))));
};
exports.LastArrivals = LastArrivals;
exports.default = exports.LastArrivals;
